import React, { useState, useContext } from 'react'
import { func } from 'prop-types'
import SignUpModal from './component/SignUpModal'

import { SignUpContext } from '@/component/Context/SignUpContext'

const NewsletterSignUpModal = ({ onClose }) => {
  const {
    error,
    setError,
    emailAddress,
    userIsSubscribed,
    handleSubscribeUser
  } = useContext(SignUpContext)

  const [formData, updateFormData] = useState({
    emailAddress: emailAddress || null
  })

  const recaptchaRef = React.createRef()
  const onReCAPTCHAChange = (code) => {
    if (!code) return
    updateFormData({
      ...formData,
      captcha: code
    })
  }

  const onChange = (e) => {
    const { value } = e.target
    updateFormData({
      ...formData,
      [e.target.name]: value.trim()
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    const recaptchaValue = recaptchaRef.current.getValue()

    if (!recaptchaValue) return setError('Please complete reCaptcha')

    const response = await fetch('/api/newsletter/signup', {
      method: 'POST',
      body: JSON.stringify(formData),
      headers: { 'content-type': 'application/json' }
    })
    const result = await response.json()
    result?.success
      ? handleSubscribeUser(result.existingSubscriber)
      : setError(result.message)
  }

  return (
    <SignUpModal
      error={error}
      userIsSubscribed={userIsSubscribed}
      subHeading="Exclusive"
      onSubmit={handleSubmit}
      onClose={() => {
        setError('')
        onClose()
      }}
      onChange={onChange}
      recaptchaRef={recaptchaRef}
      onReCAPTCHAChange={onReCAPTCHAChange}
    />
  )
}

NewsletterSignUpModal.propTypes = {
  onClose: func
}

export default NewsletterSignUpModal
